// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Participant-Profile_participant_consent__rmuX9 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.Participant-Profile_participant_consent__rmuX9>div {
  border: 1px solid var(--branded-light-purple);
  border-radius: 12px;
  padding: 0.9rem;

  label {
    font-size: 16px;
    font-weight: normal;
  }
}

.Participant-Profile_concent_dialog__3z573 {
  font-size: 12px;
  color: #383838;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 2.2rem;
}

.Participant-Profile_page_header__2Hq1R {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .p-dropdown {
    width: 20%;
    min-width: 300px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .Participant-Profile_page_header__2Hq1R {
    flex-direction: column;
    margin-bottom: 1rem;

    h3 {
      margin-bottom: 0.8rem;
    }

    .p-dropdown {
      width: 100%;
      height: 48px;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Participant-Profile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,eAAe;;EAEf;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,qBAAqB;IACvB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF","sourcesContent":[".participant_consent {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.participant_consent>div {\n  border: 1px solid var(--branded-light-purple);\n  border-radius: 12px;\n  padding: 0.9rem;\n\n  label {\n    font-size: 16px;\n    font-weight: normal;\n  }\n}\n\n.concent_dialog {\n  font-size: 12px;\n  color: #383838;\n  background-color: #FFFFFF;\n  border-radius: 8px;\n  padding: 2.2rem;\n}\n\n.page_header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n\n  :global(.p-dropdown) {\n    width: 20%;\n    min-width: 300px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .page_header {\n    flex-direction: column;\n    margin-bottom: 1rem;\n\n    h3 {\n      margin-bottom: 0.8rem;\n    }\n\n    :global(.p-dropdown) {\n      width: 100%;\n      height: 48px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"participant_consent": `Participant-Profile_participant_consent__rmuX9`,
	"concent_dialog": `Participant-Profile_concent_dialog__3z573`,
	"page_header": `Participant-Profile_page_header__2Hq1R`
};
export default ___CSS_LOADER_EXPORT___;
